import ErrorLogo from 'assets/images/error_page.png';

const ErrorPage = () => {
  return (
    <div className="pt-16 pb-12 flex flex-col ">
      <main className="flex flex-col justify-center max-w-3xl w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex-shrink-0 flex justify-center ">
          <a href="/" className="inline-flex">
            <span className="sr-only">Workflow</span>
            <img className="h-20 w-auto" src={ErrorLogo} alt="" />
          </a>
        </div>
        <div className="py-5">
          <div className="text-center">
            <h1 className="mt-2 text-2xl font-extrabold text-orange-500 tracking-tight sm:text-3xl">
              Diese Seite ist nicht verfügbar
            </h1>
            <p className="mt-2 text-base text-gray-700">
              Die von Ihnen angeforderten Inhalte können derzeit nicht angezeigt
              werden. Sie sind eventuell vorübergehend nicht verfügbar, der von
              Ihnen angeklickte Link kann abgelaufen sein oder Sie haben keine
              Berechtigung zum Abrufen dieser Seite.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ErrorPage;
